import React, { useEffect, useState } from "react";
import { HubConnectionBuilder } from "@microsoft/signalr";
import { iconPerAlertSeverityAndStatus } from "../../shared/riskIcons";
import * as alarmSeverityType from "../../shared/alarmSeverity.json";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import endPoints from "../../shared/endPoints.json";

const SignalRWatcher = (props) => {

    const [connection, setConnection] = useState(null)
    const { editMapPoint } = props;

    useEffect(() => {
        const connect = new HubConnectionBuilder()
            .withUrl(endPoints.SIGNALRHUB)
            .withAutomaticReconnect()
            .build();
        setConnection(connect);
    }, []);

    useEffect(() => {
        if (connection) {
            connection
                .start().then(() => console.log("Connection started!", connection.connectionId))
                .then(() => {
                    connection.on("ReceiveAlert", (alarm) => {
                        const parsedAlarm = JSON.parse(alarm);
                        console.log(parsedAlarm);
                        let { alarmSeverity, statusId } = parsedAlarm;

                        let alarmScore;
                        if (alarmSeverity === alarmSeverityType.ALARMSSEVERITY.HIGHRISK) {
                            alarmScore = 3;
                        } else if (alarmSeverity === alarmSeverityType.ALARMSSEVERITY.MIDDLERISK) {
                            alarmScore = 2;
                        } else {
                            alarmScore = 1;
                        }

                        let parsedAlertWithAlertScore = {
                            ...parsedAlarm,
                            riskFactorScore: alarmScore,
                            incidentParameters: {
                                alarmSeverity: parsedAlarm.alarmSeverity,
                                alarmType: parsedAlarm.alarmType,
                                riskFactorScore: alarmScore,
                            },
                        };
                        editMapPoint(
                            parsedAlertWithAlertScore,
                            iconPerAlertSeverityAndStatus(statusId, alarmSeverity)
                        );
                    });
                })
                .catch((error) => console.log(error));
        }
    }, [connection]);
    return (<></>);

};

const mapStateToProps = (state) => {
    return {
        ...state.auth,
        ...state.map,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        editMapPoint: (mapPointCoordinates, pointsStore, url, mapObject) => {
            dispatch(
                actions.editMapPointAsync(
                    mapPointCoordinates,
                    pointsStore,
                    url,
                    mapObject
                )
            );
        },
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SignalRWatcher);


